import React, {useMemo} from 'react'
import ClaytonCredentialsForm from './ClaytonCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import ClaytonMappingForm from './ClaytonMappingForm';
import { CellRenderers, columnRenderArrayData } from 'utils/tableUtils';

export default function ClaytonConfigListing(props) {

    const columns = useMemo(() => [{
        title: "Account",
        dataIndex: "accountName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Project",
        dataIndex: "projectName",
        render: columnRenderArrayData,
        width: 200
    },
    {
        title: "Branch",
        dataIndex: "branchName",
        render: CellRenderers.VALUE_OR_NA,
        width: 200
    },
], [])
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={ClaytonMappingForm}
            CredentialsForm={ClaytonCredentialsForm}
            displayComponentName="Account"
        />
    )
}